export function fullPageRedirect(path: string) {
  window.location.href = path;
  return null;
}
